
import {
  Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
  Typography, Select, MenuItem, FormHelperText, Alert, Divider
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../../components/tabs';
import { Grid } from '../../../components/table';
import { CONFIG } from '../../../../config'
import axios from 'axios';
import { ToolBar } from '../../../components/toolbar';
import { Modal } from '../../../components/modal';
import { FormA } from '../../../components/form';
import moment from 'moment';
import { getFormState } from '../../../../helpers/form';
import dayjs from 'dayjs';
import { SelectA, FileUploadA, DatePickerA } from '../../../components/form';
import { AllocationUpload } from '../upload';
import { Overall } from './overall';
import { CaseAnalytics } from './views/case-analytics/case-analytics';
import { StatusAnalytics } from './views/status-analytics/status-analytics';
import { TrendAnalytics } from './views/trend-analytics/trend-analytics';
import { CaseDataTypeAnalytics } from './views/case-data-type-analytics/case-data-type-analytics';
import { AgentAnalytics } from './views/agent-analytics/agent-analytics';
import { CallTrendView } from './views/call-trend-analytics';
import { AnalyticsSyncDateProvider } from './context/analytics-sync-date.context';

const API_HOST = CONFIG.modules['accounts'].host

// THis is the worst frontend architecture I have ever seen
// I am sorry future developer who will mainting this code
// Instead of doing routing and presenting different page
// This programmatically renders different components based on the active tab
// Which means every refresh will reset the active tab to Overview
// This is not a good practice, but it is what it is SCREW IT
const items = {
  Overview: {
    name: "Overview",
    view: (socket) => <Overall socket={socket} />,
  },

  "Case Analytics": {
    name: "Case Analytics",
    view: (socket) => <CaseAnalytics socket={socket} />,
  },
  "Case Data Type Analytics": {
    name: "Case Data Type Analytics",
    view: (socket) => <CaseDataTypeAnalytics socket={socket} />,
  },
  "Status Analytics": {
    name: "Status Analytics",
    view: (socket) => <StatusAnalytics socket={socket} />,
  },
  "Trend Analytics": {
    name: "Trend Analytics",
    view: (socket) => <TrendAnalytics socket={socket} />,
  },
  "Agent Analytics": {
    name: "Agent Analytics",
    view: (socket) => <AgentAnalytics socket={socket} />,
  },
  "Call Trend Analytics": {
    name: "Call Trend Analytics",
    view: (socket) => <CallTrendView socket={socket} />,
  }

};

const markStyle = { borderRadius: 1, ml: 2, minWidth: 300, background: '#F3D55B', mb: 3, height: 40, pl: 2, display: 'flex', alignItems: 'center' }

const wrap = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' }
const text2 = { fontSize: '.8em' }
export const Analytics = (props) => {

  // variables relation to socket

  const { roles, user, users, Designations, Departments, Languages, Districts, Campaigns } = useSelector((state) => (state.user || {}))
  const { state } = props.location


  console.log(state, 'props route');

  const [active, setActive] = useState('Overview')
  const [enableDateSync, setEnableDateSync] = useState(true)


  return (
    <AnalyticsSyncDateProvider
      enableDateSync={enableDateSync}
      setEnableDateSync={setEnableDateSync}
    >
      <>
        <Tabs
          items={items}
          active={active}
          state={state}
          onChange={(key) => {
            setActive(key)
          }}
        />
        {
          items[active] && items[active].view && //props.socket &&
          items[active].view(props.socket)
        }

      </>
    </AnalyticsSyncDateProvider>
  )
}